import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса товаров 1С (срез RP-B2a, `ProductEndpoints`, business-openapi-v1).
 * Литерал `/api/` законен только в файлах `api/urls.ts` (eslint). rid и ключи
 * экранируются: ключ из адреса окна — ввод человека.
 */
const resource = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}`
const base = (resourceId: string) => `${resource(resourceId)}/catalog`
const product = (resourceId: string, refKey: string) =>
  `${base(resourceId)}/products/${encodeURIComponent(refKey)}`

export const ONEC_PRODUCT_URLS = {
  search: (resourceId: string) => `${base(resourceId)}/products/search`,
  byBarcode: (resourceId: string) => `${base(resourceId)}/products/by-barcode`,
  card: (resourceId: string, refKey: string) => `${product(resourceId, refKey)}/card`,
  barcodes: (resourceId: string, refKey: string) => `${product(resourceId, refKey)}/barcodes`,
  barcode: (resourceId: string, refKey: string, code: string) =>
    `${product(resourceId, refKey)}/barcodes/${encodeURIComponent(code)}`,
  mainBarcode: (resourceId: string, refKey: string) => `${product(resourceId, refKey)}/barcodes/main`,
  create: (resourceId: string) => `${base(resourceId)}/products`,
  product,
  /** Ревизия базы и виды refresh (`SyncEndpoints`, native): чтение до команды обновления каталога. */
  syncCapabilities: (resourceId: string) => `${resource(resourceId)}/sync/capabilities`,
  /** `Catalog_TriggerSync`: обновить зеркало каталога этой базы из 1С. */
  triggerSync: (resourceId: string, kind: string) => `${base(resourceId)}/sync/${encodeURIComponent(kind)}`,
} as const
